import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { push } from 'connected-react-router';

import Button from '../../../Button';
import List from './List';

const YourDiary = props => (
  <div className="wrap tools plan">
    <h1>Your Diary</h1>
    <List />
    <div className="justifycentre">
      <Button onClick={() => props.dispatch(push('/dashboard'))} label="Return to Dashboard" />
    </div>
  </div>
);

YourDiary.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect(
  state => ({}),
  dispatch => ({ dispatch }),
)(YourDiary);


// WEBPACK FOOTER //
// ./src/Components/Dashboard/Pages/Diary/index.jsx